module.exports = __webpack_public_path__ + "static/media/animated_lok.ca7b3e2d.PNG";